// Helpers for dates and formatting
import { format, formatDistanceToNow, parseISO, isToday, isTomorrow, isYesterday } from 'date-fns';
import { id as idLocale } from 'date-fns/locale';

export function fmtDateLong(s) {
  if (!s) return '-';
  try {
    const d = typeof s === 'string' ? parseISO(s) : s;
    return format(d, 'EEEE, d MMMM yyyy', { locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtDate(s) {
  if (!s) return '-';
  try {
    return format(parseISO(s), 'd MMM yyyy', { locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtDateTime(s) {
  if (!s) return '-';
  try {
    return format(parseISO(s), 'd MMM yyyy, HH:mm', { locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtTime(s) {
  if (!s) return '-';
  try {
    return format(parseISO(s), 'HH:mm', { locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtRelative(s) {
  if (!s) return '-';
  try {
    return formatDistanceToNow(parseISO(s), { addSuffix: true, locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtDay(s) {
  if (!s) return '-';
  try {
    const d = parseISO(s);
    if (isToday(d)) return 'Hari Ini';
    if (isTomorrow(d)) return 'Besok';
    if (isYesterday(d)) return 'Kemarin';
    return format(d, 'EEEE, d MMM', { locale: idLocale });
  } catch {
    return s;
  }
}

export function fmtCurrency(num) {
  if (num == null) return '-';
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(num);
}
